import { render, staticRenderFns } from "./GlobalCarInfo.vue?vue&type=template&id=8ec5e9e2&scoped=true"
import script from "./GlobalCarInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalCarInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GlobalCarInfo.vue?vue&type=style&index=0&id=8ec5e9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec5e9e2",
  null
  
)

export default component.exports